import instance from "./axios.base";

const getRaiseNdTypes = async () => {
  const res = await instance.get("/service?name=ndtype&tablename=hr_pr_add");
  return res.data;
};

export { getRaiseNdTypes };
